import Textarea from '@/trio-ui/Textarea';
import * as Styles from './AdditionalInfoInput.styles';

export type AdditionalInfoInputProps = {
  name: string;
  value: string;
  isDisabled: boolean;
  onChangeAddionalInfoInput: (event: any) => void;
};

export default function AdditionalInfoInput({
  name,
  value,
  isDisabled,
  onChangeAddionalInfoInput,
}: AdditionalInfoInputProps): JSX.Element {
  return (
    <Styles.Box>
      <Textarea
        name={name}
        value={value}
        onChange={onChangeAddionalInfoInput}
        label="Additional information"
        disabled={isDisabled}
      />
    </Styles.Box>
  );
}
